import React, { useRef } from 'react'

import { Button, Input, Line } from 'components'
import { useForm } from 'react-hook-form'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalEditConsolidation.styles'
import { OptionalObjectSchema } from 'yup/lib/object'
import { yupResolver } from '@hookform/resolvers/yup'
import { DraggableDialog } from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'

interface IModalEditConsolidation {
  isOpen: boolean
  onClose: () => void
  title: string
  handleEdit: (data: any) => void
  initState: string
  formValue: string
  validationSchema?: OptionalObjectSchema<any>
}

const ModalEditConsolidation: React.FC<IModalEditConsolidation> = ({
  isOpen,
  onClose,
  title,
  initState,
  handleEdit,
  formValue,
  validationSchema
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(validationSchema) })

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      showModal={isOpen}
      onClose={onClose}
      width={'sm'}
      reference={draggableReference}
    >
      <Line />
      <FormDialog onSubmit={handleSubmit(handleEdit)}>
        <DialogTitleStyled>{title}</DialogTitleStyled>

        <DialogContentStyled style={{ width: '18rem' }}>
          <Input
            defaultValue={initState}
            control={control}
            formValue={formValue}
            label="Empresa"
            errors={errors}
            placeholder="Digite aqui..."
            maxLength={50}
          />
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button text="Voltar" variantButton="outlined" onClick={onClose} />
          <Button text="Editar" type="submit" />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalEditConsolidation
